@file:OptIn(InternalResourceApi::class)

package portalvv.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/portalvv.shared.generated.resources/"

@delegate:ResourceContentHash(1_321_382_893)
internal val Res.string.rh_chart_net_overtime: StringResource by lazy {
      StringResource("string:rh_chart_net_overtime", "rh_chart_net_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73621, 73),
      ))
    }

@delegate:ResourceContentHash(-1_544_695_190)
internal val Res.string.rh_chart_turnover: StringResource by lazy {
      StringResource("string:rh_chart_turnover", "rh_chart_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73695, 53),
      ))
    }

@delegate:ResourceContentHash(-662_035_186)
internal val Res.string.rh_chart_variables: StringResource by lazy {
      StringResource("string:rh_chart_variables", "rh_chart_variables", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73749, 58),
      ))
    }

@delegate:ResourceContentHash(-1_294_039_194)
internal val Res.string.rh_col_advance: StringResource by lazy {
      StringResource("string:rh_col_advance", "rh_col_advance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73808, 38),
      ))
    }

@delegate:ResourceContentHash(-1_263_682_245)
internal val Res.string.rh_col_cost_allowance: StringResource by lazy {
      StringResource("string:rh_col_cost_allowance", "rh_col_cost_allowance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73847, 49),
      ))
    }

@delegate:ResourceContentHash(-1_904_133_488)
internal val Res.string.rh_col_employees: StringResource by lazy {
      StringResource("string:rh_col_employees", "rh_col_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73897, 44),
      ))
    }

@delegate:ResourceContentHash(1_767_547_936)
internal val Res.string.rh_col_function: StringResource by lazy {
      StringResource("string:rh_col_function", "rh_col_function", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73942, 35),
      ))
    }

@delegate:ResourceContentHash(-913_435_819)
internal val Res.string.rh_col_hazardous: StringResource by lazy {
      StringResource("string:rh_col_hazardous", "rh_col_hazardous", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73978, 44),
      ))
    }

@delegate:ResourceContentHash(1_855_015_780)
internal val Res.string.rh_col_insalubrity: StringResource by lazy {
      StringResource("string:rh_col_insalubrity", "rh_col_insalubrity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74023, 46),
      ))
    }

@delegate:ResourceContentHash(62_584_523)
internal val Res.string.rh_col_name: StringResource by lazy {
      StringResource("string:rh_col_name", "rh_col_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74070, 27),
      ))
    }

@delegate:ResourceContentHash(-51_935_443)
internal val Res.string.rh_col_night_shift: StringResource by lazy {
      StringResource("string:rh_col_night_shift", "rh_col_night_shift", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74098, 46),
      ))
    }

@delegate:ResourceContentHash(-869_634_525)
internal val Res.string.rh_col_payment: StringResource by lazy {
      StringResource("string:rh_col_payment", "rh_col_payment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74145, 34),
      ))
    }

@delegate:ResourceContentHash(-1_222_296_280)
internal val Res.string.rh_col_registrations: StringResource by lazy {
      StringResource("string:rh_col_registrations", "rh_col_registrations", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74180, 44),
      ))
    }

@delegate:ResourceContentHash(1_875_060_300)
internal val Res.string.rh_col_requester: StringResource by lazy {
      StringResource("string:rh_col_requester", "rh_col_requester", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74225, 40),
      ))
    }

@delegate:ResourceContentHash(2_636_662)
internal val Res.string.rh_col_rmp: StringResource by lazy {
      StringResource("string:rh_col_rmp", "rh_col_rmp", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74266, 22),
      ))
    }

@delegate:ResourceContentHash(-1_360_682_306)
internal val Res.string.rh_col_salary_difference: StringResource by lazy {
      StringResource("string:rh_col_salary_difference", "rh_col_salary_difference", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74289, 52),
      ))
    }

@delegate:ResourceContentHash(1_610_468_133)
internal val Res.string.rh_col_shift: StringResource by lazy {
      StringResource("string:rh_col_shift", "rh_col_shift", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74342, 28),
      ))
    }

@delegate:ResourceContentHash(-1_720_241_764)
internal val Res.string.rh_col_status: StringResource by lazy {
      StringResource("string:rh_col_status", "rh_col_status", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74371, 29),
      ))
    }

@delegate:ResourceContentHash(-174_985_268)
internal val Res.string.rh_col_total: StringResource by lazy {
      StringResource("string:rh_col_total", "rh_col_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74401, 28),
      ))
    }

@delegate:ResourceContentHash(1_326_493_253)
internal val Res.string.rh_col_unit: StringResource by lazy {
      StringResource("string:rh_col_unit", "rh_col_unit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74430, 31),
      ))
    }

@delegate:ResourceContentHash(25_123_129)
internal val Res.string.rh_col_updated_at: StringResource by lazy {
      StringResource("string:rh_col_updated_at", "rh_col_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74462, 45),
      ))
    }

@delegate:ResourceContentHash(-2_051_160_500)
internal val Res.string.rh_delete_confirm: StringResource by lazy {
      StringResource("string:rh_delete_confirm", "rh_delete_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74508, 37),
      ))
    }

@delegate:ResourceContentHash(-663_202_701)
internal val Res.string.rh_delete_error: StringResource by lazy {
      StringResource("string:rh_delete_error", "rh_delete_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74546, 95),
      ))
    }

@delegate:ResourceContentHash(7_691_768)
internal val Res.string.rh_delete_message: StringResource by lazy {
      StringResource("string:rh_delete_message", "rh_delete_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74642, 141),
      ))
    }

@delegate:ResourceContentHash(1_999_730_254)
internal val Res.string.rh_delete_title: StringResource by lazy {
      StringResource("string:rh_delete_title", "rh_delete_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74784, 59),
      ))
    }

@delegate:ResourceContentHash(37_575_969)
internal val Res.string.rh_dismissed_by_reason: StringResource by lazy {
      StringResource("string:rh_dismissed_by_reason", "rh_dismissed_by_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74844, 54),
      ))
    }

@delegate:ResourceContentHash(-1_706_302_611)
internal val Res.string.rh_dismissed_by_sex: StringResource by lazy {
      StringResource("string:rh_dismissed_by_sex", "rh_dismissed_by_sex", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74899, 63),
      ))
    }

@delegate:ResourceContentHash(-1_599_472_897)
internal val Res.string.rh_dismissed_distinct_jobs: StringResource by lazy {
      StringResource("string:rh_dismissed_distinct_jobs", "rh_dismissed_distinct_jobs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 74963, 62),
      ))
    }

@delegate:ResourceContentHash(984_479_774)
internal val Res.string.rh_dismissed_empty: StringResource by lazy {
      StringResource("string:rh_dismissed_empty", "rh_dismissed_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75026, 90),
      ))
    }

@delegate:ResourceContentHash(-858_813_887)
internal val Res.string.rh_dismissed_top_jobs: StringResource by lazy {
      StringResource("string:rh_dismissed_top_jobs", "rh_dismissed_top_jobs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75117, 49),
      ))
    }

@delegate:ResourceContentHash(-2_113_641_049)
internal val Res.string.rh_dismissed_top_reason: StringResource by lazy {
      StringResource("string:rh_dismissed_top_reason", "rh_dismissed_top_reason", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75167, 47),
      ))
    }

@delegate:ResourceContentHash(-2_037_664_378)
internal val Res.string.rh_dismissed_top_units: StringResource by lazy {
      StringResource("string:rh_dismissed_top_units", "rh_dismissed_top_units", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75215, 50),
      ))
    }

@delegate:ResourceContentHash(1_490_376_035)
internal val Res.string.rh_dismissed_total: StringResource by lazy {
      StringResource("string:rh_dismissed_total", "rh_dismissed_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75266, 50),
      ))
    }

@delegate:ResourceContentHash(-1_335_978_275)
internal val Res.string.rh_entries_title: StringResource by lazy {
      StringResource("string:rh_entries_title", "rh_entries_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75317, 40),
      ))
    }

@delegate:ResourceContentHash(845_341_347)
internal val Res.string.rh_entries_unit_placeholder: StringResource by lazy {
      StringResource("string:rh_entries_unit_placeholder", "rh_entries_unit_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75358, 59),
      ))
    }

@delegate:ResourceContentHash(-875_802_036)
internal val Res.string.rh_history_empty: StringResource by lazy {
      StringResource("string:rh_history_empty", "rh_history_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75418, 68),
      ))
    }

@delegate:ResourceContentHash(1_208_468_019)
internal val Res.string.rh_history_title: StringResource by lazy {
      StringResource("string:rh_history_title", "rh_history_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75487, 40),
      ))
    }

@delegate:ResourceContentHash(254_871_368)
internal val Res.string.rh_history_updated_at: StringResource by lazy {
      StringResource("string:rh_history_updated_at", "rh_history_updated_at", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75528, 69),
      ))
    }

@delegate:ResourceContentHash(-740_846_293)
internal val Res.string.rh_history_updated_by: StringResource by lazy {
      StringResource("string:rh_history_updated_by", "rh_history_updated_by", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75598, 81),
      ))
    }

@delegate:ResourceContentHash(-1_369_379_874)
internal val Res.string.rh_import_error: StringResource by lazy {
      StringResource("string:rh_import_error", "rh_import_error", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75680, 123),
      ))
    }

@delegate:ResourceContentHash(-680_217_022)
internal val Res.string.rh_import_sheet: StringResource by lazy {
      StringResource("string:rh_import_sheet", "rh_import_sheet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75804, 47),
      ))
    }

@delegate:ResourceContentHash(-2_096_428_138)
internal val Res.string.rh_import_wrong_sheet: StringResource by lazy {
      StringResource("string:rh_import_wrong_sheet", "rh_import_wrong_sheet", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 75852, 153),
      ))
    }

@delegate:ResourceContentHash(319_668_880)
internal val Res.string.rh_kpi_absenteeism: StringResource by lazy {
      StringResource("string:rh_kpi_absenteeism", "rh_kpi_absenteeism", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76006, 42),
      ))
    }

@delegate:ResourceContentHash(-1_616_227_857)
internal val Res.string.rh_kpi_active: StringResource by lazy {
      StringResource("string:rh_kpi_active", "rh_kpi_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76113, 29),
      ))
    }

@delegate:ResourceContentHash(-1_833_018_532)
internal val Res.string.rh_kpi_active_variation: StringResource by lazy {
      StringResource("string:rh_kpi_active_variation", "rh_kpi_active_variation", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76049, 63),
      ))
    }

@delegate:ResourceContentHash(-1_792_106_357)
internal val Res.string.rh_kpi_admitted: StringResource by lazy {
      StringResource("string:rh_kpi_admitted", "rh_kpi_admitted", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76143, 35),
      ))
    }

@delegate:ResourceContentHash(532_340_310)
internal val Res.string.rh_kpi_dismissed: StringResource by lazy {
      StringResource("string:rh_kpi_dismissed", "rh_kpi_dismissed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76179, 36),
      ))
    }

@delegate:ResourceContentHash(1_083_172_513)
internal val Res.string.rh_kpi_net_payroll: StringResource by lazy {
      StringResource("string:rh_kpi_net_payroll", "rh_kpi_net_payroll", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76216, 46),
      ))
    }

@delegate:ResourceContentHash(-24_946_278)
internal val Res.string.rh_kpi_overtime: StringResource by lazy {
      StringResource("string:rh_kpi_overtime", "rh_kpi_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76263, 39),
      ))
    }

@delegate:ResourceContentHash(1_231_930_251)
internal val Res.string.rh_kpi_turnover: StringResource by lazy {
      StringResource("string:rh_kpi_turnover", "rh_kpi_turnover", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76303, 35),
      ))
    }

@delegate:ResourceContentHash(-387_673_511)
internal val Res.string.rh_kpi_variable_costs: StringResource by lazy {
      StringResource("string:rh_kpi_variable_costs", "rh_kpi_variable_costs", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76339, 53),
      ))
    }

@delegate:ResourceContentHash(-191_381_064)
internal val Res.string.rh_legend_bonus: StringResource by lazy {
      StringResource("string:rh_legend_bonus", "rh_legend_bonus", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76393, 43),
      ))
    }

@delegate:ResourceContentHash(1_952_778_525)
internal val Res.string.rh_legend_productivity: StringResource by lazy {
      StringResource("string:rh_legend_productivity", "rh_legend_productivity", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76437, 50),
      ))
    }

@delegate:ResourceContentHash(2_182_315)
internal val Res.string.rh_net_status_awaiting_advance: StringResource by lazy {
      StringResource("string:rh_net_status_awaiting_advance", "rh_net_status_awaiting_advance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76488, 70),
      ))
    }

@delegate:ResourceContentHash(-3_438_383)
internal val Res.string.rh_net_status_awaiting_payment: StringResource by lazy {
      StringResource("string:rh_net_status_awaiting_payment", "rh_net_status_awaiting_payment", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76559, 66),
      ))
    }

@delegate:ResourceContentHash(-1_688_044_361)
internal val Res.string.rh_overtime_100: StringResource by lazy {
      StringResource("string:rh_overtime_100", "rh_overtime_100", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76626, 39),
      ))
    }

@delegate:ResourceContentHash(-1_230_054_608)
internal val Res.string.rh_overtime_50: StringResource by lazy {
      StringResource("string:rh_overtime_50", "rh_overtime_50", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76666, 38),
      ))
    }

@delegate:ResourceContentHash(202_145_220)
internal val Res.string.rh_overtime_average: StringResource by lazy {
      StringResource("string:rh_overtime_average", "rh_overtime_average", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76705, 59),
      ))
    }

@delegate:ResourceContentHash(1_462_881_693)
internal val Res.string.rh_overtime_by_job: StringResource by lazy {
      StringResource("string:rh_overtime_by_job", "rh_overtime_by_job", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76765, 70),
      ))
    }

@delegate:ResourceContentHash(-1_685_814_646)
internal val Res.string.rh_overtime_by_manager: StringResource by lazy {
      StringResource("string:rh_overtime_by_manager", "rh_overtime_by_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76836, 74),
      ))
    }

@delegate:ResourceContentHash(1_177_238_387)
internal val Res.string.rh_overtime_chart_additionals: StringResource by lazy {
      StringResource("string:rh_overtime_chart_additionals", "rh_overtime_chart_additionals", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76911, 57),
      ))
    }

@delegate:ResourceContentHash(-913_077_613)
internal val Res.string.rh_overtime_chart_composition: StringResource by lazy {
      StringResource("string:rh_overtime_chart_composition", "rh_overtime_chart_composition", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 76969, 73),
      ))
    }

@delegate:ResourceContentHash(-386_355_731)
internal val Res.string.rh_overtime_chart_employees: StringResource by lazy {
      StringResource("string:rh_overtime_chart_employees", "rh_overtime_chart_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77043, 75),
      ))
    }

@delegate:ResourceContentHash(-496_745_047)
internal val Res.string.rh_overtime_chart_other: StringResource by lazy {
      StringResource("string:rh_overtime_chart_other", "rh_overtime_chart_other", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77119, 71),
      ))
    }

@delegate:ResourceContentHash(-1_635_118_813)
internal val Res.string.rh_overtime_chart_total: StringResource by lazy {
      StringResource("string:rh_overtime_chart_total", "rh_overtime_chart_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77191, 75),
      ))
    }

@delegate:ResourceContentHash(88_098_246)
internal val Res.string.rh_overtime_col_item: StringResource by lazy {
      StringResource("string:rh_overtime_col_item", "rh_overtime_col_item", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77267, 36),
      ))
    }

@delegate:ResourceContentHash(1_006_797_021)
internal val Res.string.rh_overtime_col_share: StringResource by lazy {
      StringResource("string:rh_overtime_col_share", "rh_overtime_col_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77304, 45),
      ))
    }

@delegate:ResourceContentHash(-375_296_791)
internal val Res.string.rh_overtime_col_value: StringResource by lazy {
      StringResource("string:rh_overtime_col_value", "rh_overtime_col_value", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77350, 37),
      ))
    }

@delegate:ResourceContentHash(-18_749_316)
internal val Res.string.rh_overtime_col_with_overtime: StringResource by lazy {
      StringResource("string:rh_overtime_col_with_overtime", "rh_overtime_col_with_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77388, 57),
      ))
    }

@delegate:ResourceContentHash(-1_574_619_735)
internal val Res.string.rh_overtime_dsr: StringResource by lazy {
      StringResource("string:rh_overtime_dsr", "rh_overtime_dsr", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77446, 47),
      ))
    }

@delegate:ResourceContentHash(-386_355_731)
internal val Res.string.rh_overtime_employees: StringResource by lazy {
      StringResource("string:rh_overtime_employees", "rh_overtime_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77549, 69),
      ))
    }

@delegate:ResourceContentHash(1_370_973_256)
internal val Res.string.rh_overtime_employees_hint: StringResource by lazy {
      StringResource("string:rh_overtime_employees_hint", "rh_overtime_employees_hint", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77494, 54),
      ))
    }

@delegate:ResourceContentHash(8_052_049)
internal val Res.string.rh_overtime_empty: StringResource by lazy {
      StringResource("string:rh_overtime_empty", "rh_overtime_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77619, 133),
      ))
    }

@delegate:ResourceContentHash(-1_252_876_690)
internal val Res.string.rh_overtime_month_breakdown: StringResource by lazy {
      StringResource("string:rh_overtime_month_breakdown", "rh_overtime_month_breakdown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77753, 71),
      ))
    }

@delegate:ResourceContentHash(-721_004_836)
internal val Res.string.rh_overtime_share: StringResource by lazy {
      StringResource("string:rh_overtime_share", "rh_overtime_share", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77825, 61),
      ))
    }

@delegate:ResourceContentHash(1_832_356_600)
internal val Res.string.rh_overtime_total: StringResource by lazy {
      StringResource("string:rh_overtime_total", "rh_overtime_total", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77887, 53),
      ))
    }

@delegate:ResourceContentHash(1_917_903_003)
internal val Res.string.rh_overtime_units_title: StringResource by lazy {
      StringResource("string:rh_overtime_units_title", "rh_overtime_units_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 77941, 63),
      ))
    }

@delegate:ResourceContentHash(298_151_051)
internal val Res.string.rh_panel_all_directors: StringResource by lazy {
      StringResource("string:rh_panel_all_directors", "rh_panel_all_directors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78005, 58),
      ))
    }

@delegate:ResourceContentHash(8_052_049)
internal val Res.string.rh_panel_empty: StringResource by lazy {
      StringResource("string:rh_panel_empty", "rh_panel_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78064, 130),
      ))
    }

@delegate:ResourceContentHash(-1_086_962_595)
internal val Res.string.rh_panel_no_data: StringResource by lazy {
      StringResource("string:rh_panel_no_data", "rh_panel_no_data", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78195, 36),
      ))
    }

@delegate:ResourceContentHash(-956_841_988)
internal val Res.string.rh_panel_not_imported: StringResource by lazy {
      StringResource("string:rh_panel_not_imported", "rh_panel_not_imported", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78232, 49),
      ))
    }

@delegate:ResourceContentHash(532_340_310)
internal val Res.string.rh_panel_tab_dismissed: StringResource by lazy {
      StringResource("string:rh_panel_tab_dismissed", "rh_panel_tab_dismissed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78282, 42),
      ))
    }

@delegate:ResourceContentHash(2_047_749_937)
internal val Res.string.rh_panel_tab_overtime: StringResource by lazy {
      StringResource("string:rh_panel_tab_overtime", "rh_panel_tab_overtime", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78325, 45),
      ))
    }

@delegate:ResourceContentHash(1_309_579_950)
internal val Res.string.rh_panel_tab_summary: StringResource by lazy {
      StringResource("string:rh_panel_tab_summary", "rh_panel_tab_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78371, 52),
      ))
    }

@delegate:ResourceContentHash(-380_146_834)
internal val Res.string.rh_panel_tab_vacancies: StringResource by lazy {
      StringResource("string:rh_panel_tab_vacancies", "rh_panel_tab_vacancies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78424, 38),
      ))
    }

@delegate:ResourceContentHash(-1_486_223_004)
internal val Res.string.rh_panel_title: StringResource by lazy {
      StringResource("string:rh_panel_title", "rh_panel_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78463, 30),
      ))
    }

@delegate:ResourceContentHash(1_335_326_430)
internal val Res.string.rh_ranking_director: StringResource by lazy {
      StringResource("string:rh_ranking_director", "rh_ranking_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78494, 67),
      ))
    }

@delegate:ResourceContentHash(-1_015_287_637)
internal val Res.string.rh_ranking_gestora: StringResource by lazy {
      StringResource("string:rh_ranking_gestora", "rh_ranking_gestora", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78562, 62),
      ))
    }

@delegate:ResourceContentHash(-966_094_839)
internal val Res.string.rh_ranking_manager: StringResource by lazy {
      StringResource("string:rh_ranking_manager", "rh_ranking_manager", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78625, 62),
      ))
    }

@delegate:ResourceContentHash(1_324_180_257)
internal val Res.string.rh_replace_confirm: StringResource by lazy {
      StringResource("string:rh_replace_confirm", "rh_replace_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78688, 42),
      ))
    }

@delegate:ResourceContentHash(-1_266_008_685)
internal val Res.string.rh_replace_message: StringResource by lazy {
      StringResource("string:rh_replace_message", "rh_replace_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78731, 134),
      ))
    }

@delegate:ResourceContentHash(-830_659_549)
internal val Res.string.rh_replace_title: StringResource by lazy {
      StringResource("string:rh_replace_title", "rh_replace_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78866, 64),
      ))
    }

@delegate:ResourceContentHash(319_668_880)
internal val Res.string.rh_tab_absenteismo: StringResource by lazy {
      StringResource("string:rh_tab_absenteismo", "rh_tab_absenteismo", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78931, 42),
      ))
    }

@delegate:ResourceContentHash(128_662_910)
internal val Res.string.rh_tab_custos: StringResource by lazy {
      StringResource("string:rh_tab_custos", "rh_tab_custos", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 78974, 37),
      ))
    }

@delegate:ResourceContentHash(-53_213_619)
internal val Res.string.rh_tab_massa_salarial: StringResource by lazy {
      StringResource("string:rh_tab_massa_salarial", "rh_tab_massa_salarial", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79012, 49),
      ))
    }

@delegate:ResourceContentHash(894_236_670)
internal val Res.string.rh_table_empty: StringResource by lazy {
      StringResource("string:rh_table_empty", "rh_table_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79062, 94),
      ))
    }

@delegate:ResourceContentHash(-1_094_493_615)
internal val Res.string.rh_unit_review_all_set: StringResource by lazy {
      StringResource("string:rh_unit_review_all_set", "rh_unit_review_all_set", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79157, 86),
      ))
    }

@delegate:ResourceContentHash(-1_789_565_004)
internal val Res.string.rh_unit_review_confirm: StringResource by lazy {
      StringResource("string:rh_unit_review_confirm", "rh_unit_review_confirm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79244, 42),
      ))
    }

@delegate:ResourceContentHash(-1_546_032_419)
internal val Res.string.rh_unit_review_director: StringResource by lazy {
      StringResource("string:rh_unit_review_director", "rh_unit_review_director", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79287, 51),
      ))
    }

@delegate:ResourceContentHash(-955_848_665)
internal val Res.string.rh_unit_review_employees: StringResource by lazy {
      StringResource("string:rh_unit_review_employees", "rh_unit_review_employees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 79339, 56),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString10Resources(map: MutableMap<String, StringResource>) {
  map.put("rh_chart_net_overtime", Res.string.rh_chart_net_overtime)
  map.put("rh_chart_turnover", Res.string.rh_chart_turnover)
  map.put("rh_chart_variables", Res.string.rh_chart_variables)
  map.put("rh_col_advance", Res.string.rh_col_advance)
  map.put("rh_col_cost_allowance", Res.string.rh_col_cost_allowance)
  map.put("rh_col_employees", Res.string.rh_col_employees)
  map.put("rh_col_function", Res.string.rh_col_function)
  map.put("rh_col_hazardous", Res.string.rh_col_hazardous)
  map.put("rh_col_insalubrity", Res.string.rh_col_insalubrity)
  map.put("rh_col_name", Res.string.rh_col_name)
  map.put("rh_col_night_shift", Res.string.rh_col_night_shift)
  map.put("rh_col_payment", Res.string.rh_col_payment)
  map.put("rh_col_registrations", Res.string.rh_col_registrations)
  map.put("rh_col_requester", Res.string.rh_col_requester)
  map.put("rh_col_rmp", Res.string.rh_col_rmp)
  map.put("rh_col_salary_difference", Res.string.rh_col_salary_difference)
  map.put("rh_col_shift", Res.string.rh_col_shift)
  map.put("rh_col_status", Res.string.rh_col_status)
  map.put("rh_col_total", Res.string.rh_col_total)
  map.put("rh_col_unit", Res.string.rh_col_unit)
  map.put("rh_col_updated_at", Res.string.rh_col_updated_at)
  map.put("rh_delete_confirm", Res.string.rh_delete_confirm)
  map.put("rh_delete_error", Res.string.rh_delete_error)
  map.put("rh_delete_message", Res.string.rh_delete_message)
  map.put("rh_delete_title", Res.string.rh_delete_title)
  map.put("rh_dismissed_by_reason", Res.string.rh_dismissed_by_reason)
  map.put("rh_dismissed_by_sex", Res.string.rh_dismissed_by_sex)
  map.put("rh_dismissed_distinct_jobs", Res.string.rh_dismissed_distinct_jobs)
  map.put("rh_dismissed_empty", Res.string.rh_dismissed_empty)
  map.put("rh_dismissed_top_jobs", Res.string.rh_dismissed_top_jobs)
  map.put("rh_dismissed_top_reason", Res.string.rh_dismissed_top_reason)
  map.put("rh_dismissed_top_units", Res.string.rh_dismissed_top_units)
  map.put("rh_dismissed_total", Res.string.rh_dismissed_total)
  map.put("rh_entries_title", Res.string.rh_entries_title)
  map.put("rh_entries_unit_placeholder", Res.string.rh_entries_unit_placeholder)
  map.put("rh_history_empty", Res.string.rh_history_empty)
  map.put("rh_history_title", Res.string.rh_history_title)
  map.put("rh_history_updated_at", Res.string.rh_history_updated_at)
  map.put("rh_history_updated_by", Res.string.rh_history_updated_by)
  map.put("rh_import_error", Res.string.rh_import_error)
  map.put("rh_import_sheet", Res.string.rh_import_sheet)
  map.put("rh_import_wrong_sheet", Res.string.rh_import_wrong_sheet)
  map.put("rh_kpi_absenteeism", Res.string.rh_kpi_absenteeism)
  map.put("rh_kpi_active", Res.string.rh_kpi_active)
  map.put("rh_kpi_active_variation", Res.string.rh_kpi_active_variation)
  map.put("rh_kpi_admitted", Res.string.rh_kpi_admitted)
  map.put("rh_kpi_dismissed", Res.string.rh_kpi_dismissed)
  map.put("rh_kpi_net_payroll", Res.string.rh_kpi_net_payroll)
  map.put("rh_kpi_overtime", Res.string.rh_kpi_overtime)
  map.put("rh_kpi_turnover", Res.string.rh_kpi_turnover)
  map.put("rh_kpi_variable_costs", Res.string.rh_kpi_variable_costs)
  map.put("rh_legend_bonus", Res.string.rh_legend_bonus)
  map.put("rh_legend_productivity", Res.string.rh_legend_productivity)
  map.put("rh_net_status_awaiting_advance", Res.string.rh_net_status_awaiting_advance)
  map.put("rh_net_status_awaiting_payment", Res.string.rh_net_status_awaiting_payment)
  map.put("rh_overtime_100", Res.string.rh_overtime_100)
  map.put("rh_overtime_50", Res.string.rh_overtime_50)
  map.put("rh_overtime_average", Res.string.rh_overtime_average)
  map.put("rh_overtime_by_job", Res.string.rh_overtime_by_job)
  map.put("rh_overtime_by_manager", Res.string.rh_overtime_by_manager)
  map.put("rh_overtime_chart_additionals", Res.string.rh_overtime_chart_additionals)
  map.put("rh_overtime_chart_composition", Res.string.rh_overtime_chart_composition)
  map.put("rh_overtime_chart_employees", Res.string.rh_overtime_chart_employees)
  map.put("rh_overtime_chart_other", Res.string.rh_overtime_chart_other)
  map.put("rh_overtime_chart_total", Res.string.rh_overtime_chart_total)
  map.put("rh_overtime_col_item", Res.string.rh_overtime_col_item)
  map.put("rh_overtime_col_share", Res.string.rh_overtime_col_share)
  map.put("rh_overtime_col_value", Res.string.rh_overtime_col_value)
  map.put("rh_overtime_col_with_overtime", Res.string.rh_overtime_col_with_overtime)
  map.put("rh_overtime_dsr", Res.string.rh_overtime_dsr)
  map.put("rh_overtime_employees", Res.string.rh_overtime_employees)
  map.put("rh_overtime_employees_hint", Res.string.rh_overtime_employees_hint)
  map.put("rh_overtime_empty", Res.string.rh_overtime_empty)
  map.put("rh_overtime_month_breakdown", Res.string.rh_overtime_month_breakdown)
  map.put("rh_overtime_share", Res.string.rh_overtime_share)
  map.put("rh_overtime_total", Res.string.rh_overtime_total)
  map.put("rh_overtime_units_title", Res.string.rh_overtime_units_title)
  map.put("rh_panel_all_directors", Res.string.rh_panel_all_directors)
  map.put("rh_panel_empty", Res.string.rh_panel_empty)
  map.put("rh_panel_no_data", Res.string.rh_panel_no_data)
  map.put("rh_panel_not_imported", Res.string.rh_panel_not_imported)
  map.put("rh_panel_tab_dismissed", Res.string.rh_panel_tab_dismissed)
  map.put("rh_panel_tab_overtime", Res.string.rh_panel_tab_overtime)
  map.put("rh_panel_tab_summary", Res.string.rh_panel_tab_summary)
  map.put("rh_panel_tab_vacancies", Res.string.rh_panel_tab_vacancies)
  map.put("rh_panel_title", Res.string.rh_panel_title)
  map.put("rh_ranking_director", Res.string.rh_ranking_director)
  map.put("rh_ranking_gestora", Res.string.rh_ranking_gestora)
  map.put("rh_ranking_manager", Res.string.rh_ranking_manager)
  map.put("rh_replace_confirm", Res.string.rh_replace_confirm)
  map.put("rh_replace_message", Res.string.rh_replace_message)
  map.put("rh_replace_title", Res.string.rh_replace_title)
  map.put("rh_tab_absenteismo", Res.string.rh_tab_absenteismo)
  map.put("rh_tab_custos", Res.string.rh_tab_custos)
  map.put("rh_tab_massa_salarial", Res.string.rh_tab_massa_salarial)
  map.put("rh_table_empty", Res.string.rh_table_empty)
  map.put("rh_unit_review_all_set", Res.string.rh_unit_review_all_set)
  map.put("rh_unit_review_confirm", Res.string.rh_unit_review_confirm)
  map.put("rh_unit_review_director", Res.string.rh_unit_review_director)
  map.put("rh_unit_review_employees", Res.string.rh_unit_review_employees)
}
